import { createSlice } from '@reduxjs/toolkit';

export const reportantesSlice = createSlice({
    name: "reportantesSlice",
    initialState: {
        loadingReportante: false,
        reportantes: []
    },
    reducers: {
        loadReportantes: (state) => {
            state.loadingReportante = true;
        },
        setReportantes: (state, action) => {
            state.loadingReportante = false;
            state.reportantes = action.payload.reportantes
        }
    }
});

export const { loadReportantes, setReportantes } = reportantesSlice.actions;